var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgU08 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 328.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-2535.00, 0.00)",
    id: "U8_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2543.48,275.20 C2544.20,272.15 2549.30,255.18 2551.72,248.04 C2557.02,233.29 2570.93,200.84 2578.05,185.53 C2581.59,178.40 2588.62,164.54 2592.11,158.07 C2595.94,151.16 2606.17,135.21 2611.43,128.17 C2616.70,121.15 2626.76,109.88 2632.47,104.49 C2637.81,99.47 2648.49,90.99 2654.54,86.97 C2659.74,83.54 2674.41,76.85 2681.53,74.56 C2684.97,73.47 2692.93,71.44 2696.06,70.94 C2699.74,70.38 2707.60,70.17 2711.65,70.53 C2715.71,70.91 2724.04,72.58 2728.52,73.90 C2734.36,75.66 2748.49,82.99 2755.10,87.17 C2761.71,91.37 2774.18,100.64 2782.79,107.60 C2789.56,113.33 2802.42,124.48 2808.50,129.90 C2814.08,135.09 2824.49,145.26 2829.53,151.10 C2834.58,157.06 2842.45,167.95 2845.29,172.93 C2848.29,178.23 2852.20,190.07 2853.91,199.21 C2855.40,207.23 2857.55,226.15 2858.08,236.05 C2858.61,250.01 2858.91,282.50 2858.89,299.72 C2858.72,309.30 2858.25,328.75 2857.74,338.22 C2856.87,349.08 2855.03,364.32 2853.56,371.91 C2852.09,379.49 2848.28,392.99 2845.95,398.91 C2843.33,405.55 2836.75,417.07 2831.52,422.75 C2828.96,425.50 2823.38,430.14 2820.37,432.02 C2817.35,433.87 2810.86,436.71 2807.39,437.69 C2800.71,439.53 2784.64,439.93 2776.67,440.09 C2742.95,440.77 2673.86,441.95 2638.49,442.45 C2622.02,442.31 2600.72,440.74 2596.10,440.15 C2591.30,439.48 2585.06,437.96 2579.76,435.84 C2574.99,433.89 2567.97,429.22 2565.81,426.55 C2563.17,423.20 2554.77,407.50 2553.32,402.59 C2550.11,391.59 2543.60,356.20 2542.12,342.94 C2541.35,336.32 2539.24,318.26 2539.09,315.42 C2538.32,300.21 2543.00,277.26 2543.48,275.20 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgU08, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/U-08.4ce5cc6f.svg";
export { ForwardRef as ReactComponent };